/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

const authTranslations = {
  login: "Anmelden",
  recover: "Passwort vergessen?",
  register: "Registrieren",
};

export default authTranslations;
